import React, { Fragment } from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import ControlledDialog from "../../../../components/ControlledDialog/ControlledDialog";
import { TextField, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(() => ({
  resize: {
    padding: 14,
  },
  label: {
    marginTop: 9,
    fontSize: 16,
    color: "#1558a2",
    fontWeight: 700,
    marginRight: 10,
  },
  actions: {
    marginTop: 20,
    display: "flex",
    justifyContent: "center",
  },
}));

const EditTrayV2 = (props) => {
  const { handleClose, open, state, onHandleChange, onSaveClick } = props;
  const classes = useStyles();

  return (
    <Fragment>
      <ControlledDialog
        hideClose
        open={open}
        disableBackdropClick
        handleClose={() => handleClose()}
        title={
          <Fragment>
            <Tooltip title="Back">
              <IconButton onClick={() => handleClose()}>
                <ArrowBackIcon fontSize="small" color="primary" />
              </IconButton>
            </Tooltip>
            <span
              style={{
                fontSize: 18,
                color: "#1558a2",
                fontWeight: 700,
              }}
            >
              Change Assigned Tray
            </span>
          </Fragment>
        }
        content={
          <Fragment>
            <Grid container direction="row" spacing={1}>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  label="User Email"
                  variant="outlined"
                  name="userEmail"
                  value={state.userEmail}
                  autoComplete="off"
                  fullWidth
                  required
                  onChange={(e) => onHandleChange(e)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  size="small"
                  type="password"
                  label="User Password"
                  autoComplete="off"
                  required
                  // inputProps={{ min: 1 }}
                  fullWidth
                  name="userPassword"
                  // error={state.quantityError}
                  value={state.userPassword}
                  onChange={(e) => onHandleChange(e)}
                  InputProps={{ classes: { input: classes.resize } }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Tray Barcode"
                  variant="outlined"
                  size="small"
                  autoComplete="off"
                  required
                  // type="number"
                  // inputProps={{ min: 1 }}
                  fullWidth
                  name="trayBarCodeWithAuthenication"
                  // error={state.quantityError}
                  value={state.trayBarCodeWithAuthenication}
                  onChange={(e) => onHandleChange(e)}
                  InputProps={{ classes: { input: classes.resize } }}
                />
              </Grid>
            </Grid>

            <div></div>

            <div className={classes.actions}>
              <Button
                onClick={() => onSaveClick()}
                disabled={state.onCancelItemStatusLoading}
                style={{ width: 100 }}
                variant="contained"
                color="primary"
              >
                {state.onCancelItemStatusLoading ? (
                  <CircularProgress size={30} />
                ) : (
                  "Save"
                )}
              </Button>
              <Button
                disabled={state.onCancelItemStatusLoading}
                style={{ marginLeft: 20 }}
                onClick={() => handleClose()}
                variant="contained"
              >
                Cancel
              </Button>
            </div>
          </Fragment>
        }
      />
    </Fragment>
  );
};

EditTrayV2.propTypes = {
  handleClose: PropTypes.func,
  //onSaveClick: PropTypes.func,
  onHandleChange: PropTypes.func,
  open: PropTypes.bool,
  state: PropTypes.object,
};

EditTrayV2.defaultProps = {
  handleClose: (fn) => fn,
  // onSaveClick: (fn) => fn,
  onHandleChange: (fn) => fn,
  open: false,
  state: {},
};

export default EditTrayV2;
